var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJuror(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 7.78491H8L4.5 14L1 7.78491Z",
    stroke: "#C7A267"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52197 0.5C5.90797 0.5 7.04639 1.64517 7.04639 3.0752C7.04625 4.5051 5.90789 5.64941 4.52197 5.64941C3.13623 5.6492 1.99867 4.50497 1.99854 3.0752C1.99854 1.6453 3.13615 0.500212 4.52197 0.5Z",
    stroke: "#C7A267"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6001 2.59998C10.8762 2.59998 11.1001 2.82383 11.1001 3.09998V9.09998C11.1001 9.37612 10.8762 9.59998 10.6001 9.59998H5.6001C5.32396 9.59998 5.1001 9.37612 5.1001 9.09998V3.09998C5.1001 2.82383 5.32396 2.59998 5.6001 2.59998H10.6001ZM7.59619 5.40564L6.67334 5.63611L7.28369 6.36462L7.21826 7.31384L8.1001 6.95837L8.98193 7.31384L8.9165 6.36462L9.52686 5.63611L8.604 5.40564L8.1001 4.59998L7.59619 5.40564Z",
    fill: "#C7A267"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuror);
export default __webpack_public_path__ + "static/media/Juror.a0d921634dcda9ae01bfebe6fba18697.svg";
export { ForwardRef as ReactComponent };